import {
  Button,
  EditIcon,
  Flex,
  Link,
  TrashIcon,
  Typography,
} from '@iheartjane/reefer';
import compact from 'lodash-es/compact';
import { useState } from 'react';

import type {
  BloomPartnerScript,
  BloomStore,
} from '@jane/business-admin/types';

interface PremiumExternalScriptProps {
  index: number;
  onDelete: (index: number) => void;
  onEdit: (index: number) => void;
  script: BloomPartnerScript;
  stores: BloomStore[];
}

export const PremiumExternalScript = ({
  script,
  index,
  stores,
  onEdit,
  onDelete,
}: PremiumExternalScriptProps) => {
  const [viewAllStores, setViewAllStores] = useState(false);

  return (
    <Flex
      flexDirection="column"
      gap={12}
      border="grays-light"
      borderWidth="1px 0 0 0"
      p={40}
    >
      <Flex justifyContent="space-between" alignItems="center" mb={4}>
        <Typography variant="body-bold">
          {script.name || `Tracking script #${index + 1}`}
        </Typography>
        <Flex gap={16}>
          <Button.Icon
            label="Remove"
            icon={<TrashIcon />}
            variant="tertiary"
            onClick={() => onDelete(index)}
          />
          <Button.Icon
            label="Edit"
            icon={<EditIcon />}
            variant="secondary"
            onClick={() => onEdit(index)}
          />
        </Flex>
      </Flex>

      <Typography variant="caps" color="grays-mid">
        Script
      </Typography>
      <Typography maxLines={5}>{script.script}</Typography>

      <Typography variant="caps" color="grays-mid" mt={12}>
        {compact([script.storeIds?.length, 'Stores']).join(' ')}
      </Typography>
      {script.storeIds?.length ? (
        <>
          <Flex flexDirection="column" gap={8}>
            {(viewAllStores
              ? script.storeIds
              : script.storeIds.slice(0, 3)
            )?.map((storeId) => (
              <Typography key={storeId}>
                {stores.find((store) => store.id === storeId)?.name}
              </Typography>
            ))}
          </Flex>
          {script.storeIds.length > 3 && (
            <Link onClick={() => setViewAllStores(!viewAllStores)}>
              {viewAllStores ? 'View less' : 'View all'}
            </Link>
          )}
        </>
      ) : (
        <Typography>All stores</Typography>
      )}
    </Flex>
  );
};
